import * as r from 'ramda';
import { handleAction } from 'redux-actions';

import * as $app from 'modules/app';
import * as actions from './actions';

const InitialState = {};

const uiReducerBase = handleAction(
  actions.setUi,
  (state, { payload: { name, value } }) =>
    value ? r.assoc(name, value, state) : r.dissoc(name, state),
  InitialState
);

export const uiReducer = (state, action) => {
  if (action.type === $app.reset().type) {
    state = undefined;
  }

  return uiReducerBase(state, action);
};
